// // Use $ instead of jQuery without replacing global $
(function ($) {

  // $('.hamburger').on('click', function () {
  //   $(this).toggleClass('active');
  //   if ($('nav .hamburger').hasClass('active')) {
  //     $('nav .nav-wrap').slideDown();
  //   } else {
  //     $('nav .nav-wrap').slideUp();
  //   }
  // });

  var nav_geo;

  function nav_link() {
    setTimeout(function () {
      nav_geo = $('body').attr('data-region');
      // Show Page if Geo location is different
      $('header nav .nav-wrap .main-nav>ul>li .sub-menu>.inner-container .col-four ul').find('li').removeClass('new');


      // For product nav only
      $('header #products .sub-inner-nav').find('li').each(function () {

        if ($(this).hasClass('australia') || $(this).hasClass('india') || $(this).hasClass('africa') || $(this).hasClass('zealand')) {

        } else {
          $(this).addClass('all');
        }

        // console.log(this);
        if ($(this).hasClass('australia') && (nav_geo === 'australia') || $(this).hasClass('all')) {
          $(this).css({'display': 'block'});

        } else if ($(this).hasClass('zealand') && (nav_geo == 'new_zealand') || $(this).hasClass('all')) {
          $(this).css({'display': 'block'});

        } else if ($(this).hasClass('india') && (nav_geo == 'in') || $(this).hasClass('all')) {
          $(this).css({'display': 'block'});

        } else if ($(this).hasClass('africa') && (nav_geo == 'africa') || $(this).hasClass('all')) {
          $(this).css({'display': 'block'});

        } else {
          $(this).css({'display': 'none'});
        }
      });

    }, 500);
  }

  $('.close-bar').on('click', function () {
    $('.bar-wrap').css({'display':'none'});
    setSpace();
  });

  $(window).scroll(function () {
    if ($(window).scrollTop() >= 50) {
      $('header').addClass('fixed-header');
    }
    else {
      $('header').removeClass('fixed-header');
    }
  });

  $(window).on('resize', function () {
    var windowWidth = $(window).width();
    if (windowWidth > 991) {
      $('header nav .nav-wrap').removeAttr('style');
      $('body').removeClass('overflow-stop');
      $('.hamburger').removeClass('active');
    }
  }).resize();

  $(document).click(function () {
    remove_Effect();
  });

  function iPad() {
    $('.ua-mobile header nav .nav-wrap .main-nav > ul > li > a:not(.btn-contact)').click(function (e) {
      e.preventDefault();
    });
  }


  $('header .nav-wrap .main-nav > ul > li > a.btn-contact').click(function (e) {
    // e.stopPropagation();
  });

  /*
   * jQuery FOR Remove Effect
   */
  function remove_Effect() {
    var window_width = $(window).width();
    if (window_width <= 991) {
      $('header .hamburger').removeClass('active');
      $('header .nav-wrap .sub-menu').slideUp();
      $('header .nav-wrap').slideUp();
      $('header .nav-wrap').removeClass('menutoogle');
      $('header .nav-wrap .inner-nav').removeClass('menu-active');
      $('header .hamburger').removeClass('active');
      $('body').removeClass('overflow-stop');

      $('header .sub-menu-inner').slideUp();
      $('header  .sub-menu > .inner-container .col-four').removeClass('inner-menu-active');
      $('header  .sub-menu > .inner-container .col-four .sub-inner-nav').removeClass('link-active');
    }
  }

  function toggle_Effect() {
    $('header nav .hamburger').click(function (e) {
      e.stopPropagation();
      $('header .hamburger').toggleClass('active');
      $('header .nav-wrap').toggleClass('menutoogle');
      $("header .nav-wrap").stop(true, true).slideToggle();
      $('header .sub-menu').slideUp();
      $('header .nav-wrap .inner-nav').removeClass('menu-active');
      $('body').toggleClass('overflow-stop');
    });

    $('header .sub-menu-inner').slideUp();
    $('header  .sub-menu > .inner-container .col-four').removeClass('inner-menu-active');
    $('header  .sub-menu > .inner-container .col-four .sub-inner-nav').removeClass('link-active');
    $('.grand-child').removeClass('link-active');
  }

  function show_menu() {
    $('header .inner-nav > a, header .inner-nav > span ').click(function (e) {
      var window_width = $(window).width();
      if (window_width <= 991) {
        e.stopPropagation();
        e.preventDefault();
        $('header .sub-menu').not($(this).siblings('.sub-menu')).slideUp();
        $(this).siblings('.sub-menu').stop(true, true).slideToggle();
        $(this).parent().toggleClass('menu-active');
        $(this).parent().siblings('.inner-nav').removeClass('menu-active');

        $('header .sub-menu-inner').slideUp();
        $('header  .sub-menu > .inner-container .col-four').removeClass('inner-menu-active');
        $('header  .sub-menu > .inner-container .col-four .sub-inner-nav').removeClass('link-active');
        $('.grand-child').removeClass('link-active');
      }
    });
  }

  function show_inner_menu() {
    $('header nav .nav-wrap .main-nav > ul > li .sub-inner-nav .inner-link').click(function (e) {
      var window_width = $(window).width();
      if (window_width <= 991) {
        e.stopPropagation();
        e.preventDefault();
        $('.sub-menu-inner').not($(this).siblings('.sub-menu-inner')).slideUp();
        $(this).siblings('.sub-menu-inner').slideToggle();
        $('header  .sub-menu > .inner-container .col-four').removeClass('inner-menu-active');
        $(this).parent().parent().parent().toggleClass('inner-menu-active');
        $('header  .sub-menu > .inner-container .col-four .sub-inner-nav').not($(this).parent()).removeClass('link-active');
        $(this).parent().toggleClass('link-active');
        $('.grand-child').removeClass('link-active');
      }
    });
  }

  function navBlock() {
    var count = $("header nav .nav-wrap .main-nav>ul>li#solutions .sub-menu .col-eight>div>div>ul>li");
    $("header nav .nav-wrap .main-nav>ul>li#solutions .sub-menu .col-eight>div>div>ul").each(function (index, sel) {

      var row = $(sel).find(count).slice(0, 9);
      row.wrapAll("<div class='col-three second-block'></div>");

      setTimeout(function () {
        var row = $(sel).find(count).slice(9, 17);
        row.wrapAll("<div class='col-three third-block'></div>");
      }, 500);

      setTimeout(function () {
        var row = $(sel).find(count).slice(17, 24);
        row.wrapAll("<div class='col-three fourth-block'></div>");
      }, 1000);
    });
  }

  function show_solution_inner_menu() {
    setTimeout(function () {
      $('header nav .nav-wrap .main-nav>ul>li#solutions .sub-menu .col-eight ul li.grand-child>ul').addClass('sub-menu-inner');
      $(document).on('click', 'header nav .nav-wrap .main-nav .grand-child > a', function (e1) {
        e1.stopPropagation();
        e1.preventDefault();
        console.log(1);
        $('.sub-menu-inner').not($(this).siblings('.sub-menu-inner')).slideUp();
        $(this).siblings('.sub-menu-inner').slideToggle();
        $('.grand-child').not($(this).parent()).removeClass('link-active');
        $('header  .sub-menu > .inner-container .col-four').removeClass('inner-menu-active');
        $(this).parent().parent().parent().toggleClass('inner-menu-active');
        $('header  .sub-menu > .inner-container .col-four .sub-inner-nav').not($(this).parent()).removeClass('link-active');
        $(this).parent().toggleClass('link-active');
      });
    }, 1100);
  }


  function hoverState() {
    var winWidth = $(window).width();

    function makeTall() {
      $(this).addClass('hover-active');
    }

    function makeShort() {
      $(this).removeClass('hover-active');
    }

    if (winWidth > 991) {
      $("#solutions").hoverIntent(makeTall, makeShort);
      $("#products").hoverIntent(makeTall, makeShort);
      $("#parts-and-services").hoverIntent(makeTall, makeShort);
      $("#about-us").hoverIntent(makeTall, makeShort);
    } else {
      $("header nav .nav-wrap .main-nav>ul>li.inner-nav").removeClass('hover-active');
    }
  }

  function setSpace(){
    var header_height1 = $("header").height();
    $("body").css({"padding-top": header_height1});
  }

  $(document).ready(function () {
    toggle_Effect();
    show_menu();
    iPad();
    show_inner_menu();
    hoverState();

    nav_link();

    $('header nav .nav-wrap .main-nav>ul>li .sub-menu>.inner-container .col-four .image-wrap .content a').addClass('link-icon');


    $('header #solutions .sub-menu .views-element-container ul li').each(function () {
      var len = $(this).find('ul').length;
      if (len > 2) {
        $(this).addClass('grand-child');
      }
    });

    setTimeout(function () {
      navBlock();
    }, 1000);

    setSpace();
  });

  $(window).on('resize', function () {
    setSpace();
  });

  $(window).on('load', function () {
    $("header").fadeIn();
    show_solution_inner_menu();
  });

  $(window).on('load resize', function () {
    var win_width = $(window).width();
    var win_height = $(window).height();
    var header_height = $("header").height();
    var total = win_height - header_height;
    // $("body").css({"padding-top": header_height});

    if (win_width >= 992) {
      var left_space = $("header .container").offset().left;
      // console.log(left_space, win_width, header_height);
      $('header nav .nav-wrap .main-nav>ul>li .sub-menu').css({'width': win_width, 'left': -left_space});
      $('header nav .nav-wrap').removeAttr('style');
    } else {
      $('header nav .nav-wrap .main-nav>ul>li .sub-menu').removeAttr('style');
      $('header nav .nav-wrap .main-nav>ul>li').removeClass('menu-active');
      $('header nav .nav-wrap').css({'height': total + 'px'});
    }

  });

})(jQuery);